<div class="overflow-hidden w-full bg-white rounded-md">
    <app-button
        (click)="handleDownload()"
        variant="outline"
        icon="material-symbols:download-rounded"
        [size]="size()"
        expand
    >
        <p class="truncate max-w-[15rem]">{{ name() }}</p>
    </app-button>
</div>
